var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYourTurn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_441_838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6563 10.7898C14.6563 14.1605 12.0674 16.894 8.87503 16.894C5.68271 16.894 3.09375 14.1605 3.09375 10.7898C3.09375 7.41914 5.68271 4.68555 8.87503 4.68555C12.0674 4.68555 14.6563 7.41914 14.6563 10.7898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7388 27.6431C17.5303 22.6624 13.6359 18.6895 8.87487 18.6895C4.11382 18.6895 0.208433 22.6624 0 27.6431H17.7388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5302 15.8399C17.2889 15.8167 17.1024 15.643 17.0475 15.3997C16.9927 15.1565 17.1024 14.9132 17.2999 14.7858C18.0568 14.3341 18.6711 13.7433 19.088 13.0831C18.1884 12.4692 17.4425 11.6932 16.9159 10.8244C16.3125 9.82829 16.0054 8.73948 16.0054 7.60435C16.0054 3.77037 19.5926 0.654541 24.0026 0.654541C28.4126 0.654541 31.9999 3.77037 31.9999 7.60435C31.9999 11.4383 28.4126 14.5542 24.0026 14.5542C23.7503 14.5542 23.487 14.5542 23.2237 14.5194C21.8196 15.3997 20.0643 15.8746 18.2762 15.8746C18.0239 15.8746 17.7716 15.8746 17.5302 15.8515V15.8399ZM22.8508 12.7588L23.2896 12.8051C23.5309 12.8283 23.7723 12.8399 24.0136 12.8399C27.535 12.8399 30.3982 10.4885 30.3982 7.59277C30.3982 4.69701 27.535 2.34566 24.0136 2.34566C20.4922 2.34566 17.629 4.69701 17.629 7.59277C17.629 9.22597 18.5505 10.7433 20.1411 11.7627L21.282 12.4808L20.6238 13.697C20.6238 13.697 20.569 13.8013 20.5361 13.8592C21.2381 13.6623 21.8964 13.3727 22.4668 13.0136L22.8398 12.7704L22.8508 12.7588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0902 8.91312C24.7869 8.91312 25.3518 8.31674 25.3518 7.58107C25.3518 6.8454 24.7869 6.24902 24.0902 6.24902C23.3934 6.24902 22.8286 6.8454 22.8286 7.58107C22.8286 8.31674 23.3934 8.91312 24.0902 8.91312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7328 8.91312C28.4295 8.91312 28.9943 8.31674 28.9943 7.58107C28.9943 6.8454 28.4295 6.24902 27.7328 6.24902C27.036 6.24902 26.4712 6.8454 26.4712 7.58107C26.4712 8.31674 27.036 8.91312 27.7328 8.91312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2728 8.91312C20.9639 8.91312 21.5344 8.3108 21.5344 7.58107C21.5344 6.85134 20.9639 6.24902 20.2728 6.24902C19.5817 6.24902 19.0112 6.85134 19.0112 7.58107C19.0112 8.3108 19.5817 8.91312 20.2728 8.91312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27,
    fill: "white",
    transform: "translate(0 0.643066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYourTurn1);
export default __webpack_public_path__ + "static/media/ic_your_turn_1.c532fb5cada56f061977e3016ba6864c.svg";
export { ForwardRef as ReactComponent };